import type { VisibleSignalFilter } from "../datapoints/visible-signal-filter";

// Engineering-signal predicate for the equipment detail lens (Talotekniikan toimivuus).
// These rows are present in the KB signal set but are deliberately hidden on the judgment
// lens — they are internal diagnostics, not operator-facing measurements.
export function is_engineering_signal(name: string): boolean {
  return (
    name === "reliability_score" ||
    name.startsWith("behavior_") ||
    name.startsWith("kb_behavior_")
  );
}

// Scopes the embedded SignaalitList to one equipment. Membership is this source's live
// names plus activated names (declared_data_points and context-setpoint family ids).
// Mapping is not required — an unmapped asetusarvo still belongs on the list. Engineering
// diagnostics stay hidden on this judgment lens.
export function build_equipment_visible_signals(
  source_id: string,
  live_names: readonly string[],
  activated_names: readonly string[] = [],
): VisibleSignalFilter {
  const names: string[] = [];
  const seen = new Set<string>();
  for (const name of [...live_names, ...activated_names]) {
    if (is_engineering_signal(name) || seen.has(name)) continue;
    seen.add(name);
    names.push(name);
  }
  return [{ source_id, names }];
}
